import { createContext, useCallback, useContext, useMemo } from 'react';

import { IWorkspaceUser } from 'src/@types/workspace-info';
import { useBoardUsers } from '../shared/useBoardUsers';
import { BoardQueryResult } from './useBoardQuery';

type BoardContext = {
  board: BoardQueryResult;
  tableId: string;
  boardParticipants: IWorkspaceUser[];
  openAIFolderContext(folderId: string): void;
};

const context = createContext<BoardContext>(null as any);

export const useBoardContext = () => useContext(context);

type BoardContextProps = {
  children: React.ReactNode;
  board: BoardQueryResult;
  tableId: string;
};

export const BoardContextProvider = ({
  children,
  board,
  tableId,
}: BoardContextProps) => {
  const openAIFolderContext = useCallback((folderId: string) => {
    // const folder = board.folders.find((f) => f._id === folderId);
    // if (!folder) return;
    // setFolderContext({
    //   boardId: board._id,
    //   boardName: board.name,
    //   folderId: folder._id,
    //   folderName: folder.name,
    // });
  }, []);

  const boardParticipants = useBoardUsers(board._id);

  const value = useMemo<BoardContext>(
    () => ({
      board,
      tableId,
      openAIFolderContext,
      boardParticipants,
    }),
    [board, tableId, openAIFolderContext, boardParticipants],
  );

  return <context.Provider value={value}>{children}</context.Provider>;
};
